module.exports = __webpack_public_path__ + "img/svg/background-user-rankings-crown-mobile.a84251f6f7d121f78aa176967344e424.svg";